import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import DatePickerTextbox from "@/components/DatePickerTextbox.vue";
let BenefitsFixedModal = class BenefitsFixedModal extends Vue {
    shortDate(date) {
        return window.dateHandler.formatDateNoTime(date);
    }
    deleteBenefit() {
        this.$store
            .dispatch("deleteEmployeeBenefit", {
            userId: this.$props.employee.userId,
            benefitId: this.$props.benefitId,
        })
            .then((response) => {
            this.$data.deleteDialog = false;
            this.$store.dispatch("ToastMessage", {
                type: "any",
                message: "Fixed salary Removed",
            });
            this.$emit("close");
            //send reload event
            window.eventBus.$emit("reloadBenefitsForUser");
        })
            .catch((err) => {
            window.errorHandler.logError(err, "components/BenefitsLevelModal.vue - deleteLevel");
        });
    }
    async getCurrentBenefitLevel() {
        this.$store
            .dispatch("getFixedSalary", {
            userId: this.$props.employee.userId,
            benefitId: this.$props.benefitId,
        })
            .then((response) => {
            this.$data.selectedFixedBenefit = response.data;
            this.$data.loading = false;
        })
            .catch((err) => {
            window.errorHandler.logError(err, "components/BenefitsFixedModal.vue - loadLevel");
        });
    }
    updateFixedBenefit(selectedFixedBenefit) {
        this.$store
            .dispatch("adminUpdateFixedBenefitAsync", {
            userId: this.$props.employee.userId,
            data: selectedFixedBenefit,
        })
            .then((response) => {
            this.$store.dispatch("ToastMessage", {
                type: "any",
                message: "The fixed benefit has been updated",
            });
            //@ts-ignore
            this.close(true);
        })
            .catch((err) => {
            window.errorHandler.logError(err, "components/BenefitsFixedModal.vue - updateFixedBenefit");
        });
    }
};
BenefitsFixedModal = __decorate([
    Component({
        data() {
            return {
                trueVal: true,
                loading: true,
                theme: this.$store.getters.getTheme,
                selectedFixedBenefit: {
                    name: "",
                    fixedSalary: 0,
                    fixedVariableSalary: 0,
                    pension: 0,
                    vacationDays: 0,
                    from: null,
                    to: null,
                    workPercentage: null,
                    bonusProgram: "None",
                    maxBonus: 0,
                },
                deleteDialog: false,
                invalidFields: [],
                fixedHeaders: [
                    { text: "Fixed Salary", value: "fixedSalary" },
                    { text: "From", value: "from" },
                    { text: "To", value: "to" },
                    { text: "", value: "delete" },
                ],
            };
        },
        props: ["employee", "benefitId", "closeBenefitsModal"],
        watch: {
            "selectedFixedBenefit": function (newVal) {
                console.log("selectedFixedBenefit: ", JSON.stringify(newVal));
            },
        },
        async mounted() {
            if (!this.$props.benefitId)
                return this.$data.loading = false;
            this.getCurrentBenefitLevel();
        },
        computed: {
            showModal: {
                get() {
                    return this.$data.trueVal;
                },
                set(newValue) {
                    this.$data.trueVal = newValue;
                    if (this.$data.trueVal === false) {
                        this.$emit("close"); //we need to send the close event if the dialog is closed by clicking outside rather than on the button
                    }
                },
            },
        },
        methods: {
            close(cascade = false) {
                this.$emit("close");
                this.$data.selectedFixedBenefit = {
                    name: "",
                    fixedSalary: 0,
                    fixedVariableSalary: 0,
                    pension: 0,
                    vacationDays: 0,
                    from: null,
                    to: null,
                    workPercentage: null,
                    bonusProgram: "None",
                    maxBonus: 0,
                };
            },
            validateName(value) {
                if (!value)
                    return "Name is required";
                return true; // Validation passed
            },
            validateNumber(value) {
                const parsedValue = parseFloat(value);
                return (!isNaN(parsedValue) && parsedValue >= 0) || "Enter a valid number";
            },
            validateDate(value) {
                if (!value)
                    return "Date is required";
                return true; // Validation passed
            },
            validateWorkPercentage(value) {
                const parsedValue = parseFloat(value);
                if (isNaN(parsedValue)) {
                    return "Enter a valid number";
                }
                if (parsedValue < 0 || parsedValue > 100) {
                    return "Work percentage must be between 0 and 100";
                }
                return true; // Validation passed
            },
            validateAndUpdate(selectedFixedBenefit) {
                //@ts-ignore
                if (this.validateName(selectedFixedBenefit.name) !== true)
                    this.$data.invalidFields.push("Name");
                //@ts-ignore
                if (this.validateNumber(selectedFixedBenefit.fixedSalary) !== true)
                    this.$data.invalidFields.push("Fixed salary");
                //@ts-ignore
                if (this.validateNumber(selectedFixedBenefit.fixedVariableSalary) !== true)
                    this.$data.invalidFields.push("Fixed variable salary");
                //@ts-ignore
                if (this.validateWorkPercentage(selectedFixedBenefit.workPercentage) !== true)
                    this.$data.invalidFields.push("Work percentage");
                //@ts-ignore
                if (this.validateNumber(selectedFixedBenefit.pension) !== true)
                    this.$data.invalidFields.push("Pension");
                //@ts-ignore
                if (this.validateNumber(selectedFixedBenefit.vacationDays) !== true)
                    this.$data.invalidFields.push("Vacation days");
                //@ts-ignore
                if (this.validateDate(selectedFixedBenefit.from) !== true)
                    this.$data.invalidFields.push("Level from");
                if (this.$data.invalidFields && this.$data.invalidFields.length === 0) {
                    this.updateFixedBenefit(selectedFixedBenefit);
                }
                else {
                    this.$store.dispatch("ToastMessage", {
                        type: "error",
                        message: "Invalid fields: " + this.$data.invalidFields.join(", ") + ".",
                    });
                    this.$data.invalidFields = [];
                    console.log('Validation failed. Please check the input.');
                }
            },
        },
        components: {
            DatePickerTextbox,
        },
    })
], BenefitsFixedModal);
export default BenefitsFixedModal;
